import { render, staticRenderFns } from "./SafetyAlerts.vue?vue&type=template&id=d34a139a&scoped=true&"
import script from "./SafetyAlerts.vue?vue&type=script&lang=js&"
export * from "./SafetyAlerts.vue?vue&type=script&lang=js&"
import style0 from "./SafetyAlerts.vue?vue&type=style&index=0&id=d34a139a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34a139a",
  null
  
)

export default component.exports